






import { Component, Vue } from "vue-property-decorator";
import ChangePassword from "./ChangePassword.vue";

@Component({
	components: {
		"change-password": ChangePassword,
	},
})
export default class AccountSecurity extends Vue {}
